import Joi from 'joi'

export const customerSatisfactionSchema = Joi.object({
  auto: Joi.boolean().allow(null),
  commentEnabled: Joi.boolean().allow(null),
  commentEnabledBelow: Joi.number().integer().allow(null),
  finishText: Joi.string().allow('', null),
  footer: Joi.string().allow('', null).max(40),
  heading: Joi.string().allow('', null).max(40),
  mailboxIds: Joi.array().min(1).required().messages({
    'array.min': `mailboxIds must contain at least one item`,
  }),
  name: Joi.string().max(40).trim().required().messages({
    'string.empty': `Name cannot be an empty field`,
    'any.required': `Name is a required field`,
    'string.max': `Name length must be less than or equal to 40 characters`,
  }),
  ratingsType: Joi.string().allow('', null).max(40),
  subHeading: Joi.string().allow('', null).max(40),
  subject: Joi.string().max(40).trim().required().messages({
    'string.empty': `Subject cannot be an empty field`,
    'any.required': `Subject is a required field`,
    'string.max': `Subject length must be less than or equal to 40 characters`,
  }),
  commentTitle: Joi.string().allow('', null).max(60),
  description: Joi.string().allow('', null).max(200),
})
